import React, { ReactElement, useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { History } from 'history';
import i18n from 'i18next';
import { Row, Col, Button } from 'antd';
import { Brand } from './layout/Brand';
import GuestIcon from '../assets/images/png/guest-high.png';
import CookIcon from '../assets/images/png/chef-high.png';
import { useSelector, useDispatch } from 'react-redux';
import { getAppGlobalState } from '../store/app-globals/selectors';
import { setLoading } from '../store/app-globals/actions';
import { getUserState } from '../store/user/selector';
import { DropdownSelect } from './layout/GlobalTranslation';

export interface WelcomeButtonProps {
  icon: string;
  title: string;
  description: string;
  onClick?: (e?: React.MouseEvent) => void;
}

export const WelcomeButton: React.FC<WelcomeButtonProps> = ({
  icon,
  title,
  description,
  onClick,
}): ReactElement => (
  <button className="welcome-button" onClick={onClick}>
    <div className="welcome-button-icon">
      <img src={icon} alt="welcome-button-icon" />
    </div>
    <div className="welcome-button-title">
      <span>{title}</span>
    </div>
    <div className="welcome-button-description">{description}</div>
  </button>
);

export const Welcome: React.FC = (): ReactElement => {
  const history: History = useHistory();
  const navigateToPath = (path: string) => (): void => {
    history.push(path);
  };

  const { isLoading } = useSelector(getAppGlobalState);
  const { user } = useSelector(getUserState);
  const { userid } = user;
  const [loading, setStateLoading] = useState(isLoading);
  const dispatch = useDispatch();

  const animateRef = useRef(!isLoading);
  const animatedLogoClassname =
    !loading && !userid
      ? animateRef.current
        ? ''
        : 'slide-in-blurred-bottom'
      : '';
  const animatedButtonsClassname = animateRef.current
    ? ''
    : 'slide-in-fwd-center';

  useEffect(() => {
    const loadingTimeout = setTimeout(() => {
      if (userid)
        user.accountType === 'admin'
          ? history.push('/admin')
          : history.push('/profile');
      setStateLoading(false);
      dispatch(setLoading(false, ''));
    }, 2500);
    return () => clearTimeout(loadingTimeout);
  }, [isLoading, user.accountType, userid, history, dispatch]);

  return (
    <Row justify={'center'} align="middle" className="welcome-screen">
      <div className="welcome-translation">
        <DropdownSelect />
      </div>
      <div className={animatedLogoClassname}>
        <Brand />
      </div>
      {!loading && !userid && (
        <React.Fragment>
          <Col
            span={24}
            className={`welcome-button-container ${animatedButtonsClassname}`}
          >
            <WelcomeButton
              icon={GuestIcon}
              title={i18n.t('Guest')}
              description={i18n.t('GUEST_BUY_DESCRIPTION')}
              onClick={navigateToPath('/authentication/login/index/guest')}
            />
          </Col>
          <Col
            span={24}
            className={`welcome-button-container ${animatedButtonsClassname}`}
          >
            <WelcomeButton
              icon={CookIcon}
              title={i18n.t('Cook')}
              description={i18n.t('GUEST_SELL_DESCRIPTION')}
              onClick={navigateToPath('/authentication/login/index/cook')}
            />
          </Col>
          {/* <Col flex="1 0 100px" className="bottom-link">
            <Button
              type="link"
              onClick={navigateToPath(
                `/authentication/login/email/:accountType`
              )}
            >
              {i18n.t('ADMIN_LOGIN')}
            </Button>
            <Button
              type="link"
              onClick={navigateToPath('/dashboard')}
              className="skip-btn"
            >
              {i18n.t('SKIP')}
            </Button>
          </Col> */}
          <Col flex="1 0 100px" className="bottom-link">
            <Button
              type="primary"
              onClick={navigateToPath('/dashboard')}
              className="skip-btn"
            >
              {i18n.t('SKIP')}
            </Button>
            {/* <div className="skip-button" onClick={navigateToPath('/dashboard')}>
              <span>{i18n.t('SKIP')}</span>
            </div> */}
          </Col>
        </React.Fragment>
      )}
    </Row>
  );
};
